import { useSupabase } from '@/hooks/useSupabase'
import { supabase } from '@/lib/supabase'
import type { PulseData } from '@/types'

export function usePulse() {
  return useSupabase<PulseData>(async () => {
    try {
      // Get stats
      const [conceptsResult, connectionsResult, ingestionsResult, healthResult, interpretationsResult] = await Promise.all([
        supabase.from('concepts').select('id', { count: 'exact' }),
        supabase.from('connections').select('id', { count: 'exact' }),
        supabase.from('ingestions').select('id', { count: 'exact' }),
        supabase.from('health_scores')
          .select('overall_score')
          .order('calculated_at', { ascending: false })
          .limit(1)
          .single(),
        supabase.from('interpretations')
          .select('id', { count: 'exact' })
          .eq('status', 'new')
      ])

      const stats = {
        total_concepts: conceptsResult.count || 0,
        total_connections: connectionsResult.count || 0,
        total_ingestions: ingestionsResult.count || 0,
        health_score: ((healthResult.data?.overall_score || 0) > 1 ? (healthResult.data?.overall_score || 0) / 100 : (healthResult.data?.overall_score || 0)),
        new_interpretations: interpretationsResult.count || 0
      }

      // Get emergences
      const { data: emergences } = await supabase
        .from('emergences')
        .select('*')
        .eq('status', 'new')
        .order('created_at', { ascending: false })
        .limit(5)

      // Get recent ingestions
      const { data: recent_ingestions } = await supabase
        .from('ingestions')
        .select(`
          *,
          primary_domain:domains!ingestions_primary_domain_id_fkey(*)
        `)
        .order('ingested_at', { ascending: false })
        .limit(5)

      // Get top concepts
      const { data: top_concepts } = await supabase
        .from('concepts')
        .select(`
          *,
          domain:domains(*)
        `)
        .order('synapse_strength', { ascending: false })
        .limit(10)

      return {
        stats,
        emergences: emergences || [],
        recent_ingestions: recent_ingestions || [],
        top_concepts: top_concepts || []
      }
    } catch {
      return {
        stats: {
          total_concepts: 0,
          total_connections: 0,
          total_ingestions: 0,
          health_score: 0,
          new_interpretations: 0
        },
        emergences: [],
        recent_ingestions: [],
        top_concepts: []
      }
    }
  })
}